import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import LabelsAPI from '../../api/labels';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { LABEL_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
  labelData: [],
};

export const getters = {
  getLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getLabelsOnSidebar(_state) {
    return _state.records
      .filter(record => record.show_on_sidebar)
      .sort((a, b) => a.title.localeCompare(b.title));
  },
  labelsdata(_state){
    return _state.labelData;
  }
};

export const actions = {
  revalidate: async function revalidate({ commit }, { newKey }) {
    try {
      const isExistingKeyValid = await LabelsAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await LabelsAPI.refetchAndCommit(newKey);
        commit(types.SET_LABELS, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },

  get: async function getLabels({ commit }) {
    commit(types.SET_LABEL_UI_FLAG, { isFetching: true });
    try {
      const response = await LabelsAPI.get(true);
      const sortedLabels = response.data.payload.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      commit(types.SET_LABELS, sortedLabels);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createLabels({ commit }, cannedObj) {
    commit(types.SET_LABEL_UI_FLAG, { isCreating: true });
    try {
      const response = await LabelsAPI.create(cannedObj);
      AnalyticsHelper.track(LABEL_EVENTS.CREATE);
      commit(types.ADD_LABEL, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateLabels({ commit }, { id, ...updateObj }) {
    commit(types.SET_LABEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await LabelsAPI.update(id, updateObj);
      AnalyticsHelper.track(LABEL_EVENTS.UPDATE);
      commit(types.EDIT_LABEL, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteLabels({ commit }, id) {
    commit(types.SET_LABEL_UI_FLAG, { isDeleting: true });
    try {
      await LabelsAPI.delete(id);
      AnalyticsHelper.track(LABEL_EVENTS.DELETED);
      commit(types.DELETE_LABEL, id);
      await LabelsAPI.refetchAndCommit();
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isDeleting: false });
    }
  },
  getLabelsdata: async ({ commit }, id) => {
    commit(types.SET_LABEL_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await LabelsAPI.getdata(id);
      const { data: responsedata } = response;
      return responsedata;
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isFetchingItem: false });
    }
  },
  getlabelsindex: async ({commit})=>{
    commit(types.SET_LABEL_UI_FLAG, { isFetching: true }); 
    try{
      const response = await LabelsAPI.getall();
      const responsedata=response.data.payload;
      commit(types.SET_LABEL_UI_FLAG, { isFetching: false }); 
      commit(types.SET_LABELS_DATA, responsedata);
      return responsedata;
    }catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LABEL_UI_FLAG, { isFetching: false });
    }
  },
  deleteLabelTrigger: async({commit},{labelId,triggerId})=>{
    commit(types.SET_LABEL_UI_FLAG, { isDeleting: true });
    try{
      const response=await LabelsAPI.deletetrigger(labelId,triggerId);
      commit(types.SET_LABEL_UI_FLAG, { isDeleting: false });
      return response;
    }catch (error) {
      // Ignore error
    } 
  },
  deleteContactAutomationTrigger: async({commit},{labelId,triggerId})=>{
    commit(types.SET_LABEL_UI_FLAG, { isDeleting: true });
    try{
      await LabelsAPI.deleteContactAutomationTrigger(labelId,triggerId);
      commit(types.SET_LABEL_UI_FLAG, { isDeleting: false });
    }catch (error) {
      commit(types.SET_LABEL_UI_FLAG, { isDeleting: false });
      throw error;
    } 
  }

};

export const mutations = {
  [types.SET_LABEL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_LABELS]: MutationHelpers.set,
  [types.ADD_LABEL]: MutationHelpers.create,
  [types.EDIT_LABEL]: MutationHelpers.update,
  [types.DELETE_LABEL]: MutationHelpers.destroy,
  [types.SET_LABELS_DATA](_state,data){
    _state.labelData=data;
  } 
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
